import React, { createContext, useContext } from "react";
import { RadioGroupProps } from "./types";
import { RadioGroupContainer } from "./styled";

// Contexto para fornecer o name do grupo para os Radio filhos
const RadioGroupContext = createContext<string>("");

export const useRadioGroupContext = () => useContext(RadioGroupContext);

export const RadioGroup: React.FC<RadioGroupProps> = ({
  name,
  label,
  children,
  className,
  directionItems = "row",
  ...rest
}) => (
  <RadioGroupContext.Provider value={name}>
    <RadioGroupContainer
      className={`${name} ${directionItems} ${className}`}
      {...rest}
    >
      {children}
    </RadioGroupContainer>
  </RadioGroupContext.Provider>
);

export default RadioGroup;
